import { oldApiInstance, ssrRubyApiInstance } from 'functions/request';
import { isClient } from 'functions/isClient';

export const fetchTag = ({ tag_id, product_name, brand, retailer } = {}) => {
  if (isClient()) {
    return oldApiInstance.get('/shop/tag', {
      params: {
        tag_id,
        name: product_name,
        brand,
        retailer,
      },
    });
  }

  return ssrRubyApiInstance.get('/api/v2/shop/tag', {
    params: {
      tag_id,
      name: product_name,
      brand,
      retailer,
    },
  });
};

export const fetchCoupons = ({ rule_id } = {}) => oldApiInstance.get(`/shop/${rule_id}/shop_offers`);

export const fetchYouMintAlsoLike = ({ id } = {}) => oldApiInstance.get(`/shop/tags/${id}/you_might_also_like`);

export const fetchSimilar = ({ id } = {}) => oldApiInstance.get(`/shop/tags/${id}/similar_tags`);
